import React from "react";
import { Icon } from "@iconify/react";
import { Col, Container, Image, Row } from "react-bootstrap";
import {
  FaCcVisa,
  FaCcStripe,
  FaCcMastercard,
  FaFacebook,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { CiBank } from "react-icons/ci";
import FooterCard from "../FooterCards/whychoose";
import { RiSecurePaymentLine } from "react-icons/ri";
import { IoRocket } from "react-icons/io5";
import { MdSupport } from "react-icons/md";
import { GiReturnArrow } from "react-icons/gi";

import "./Footer.css";

export default function Footer() {
  const handleLoginSignup = () => {
    const currentPath = router.asPath;
    router.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
  };

  return (
    <footer>
      <FooterCard />
      <Container>
        <Row className="footer_content">
          <div>
            <div className="card-container">
              {/* <div className="card_new">
                <div className="icon">
                  <IoRocket fontSize={50} color="#f9a826" />
                </div>
                <div className="content">
                  <strong>Fast Shipping</strong>
                  <p>
                    Same-day shipping until 3PM CST, with expedited options
                    available.
                  </p>
                </div>
              </div>

              <div className="card_new">
                <div className="icon">
                  <GiReturnArrow fontSize={50} color="#f9a826" />
                </div>
                <div className="content">
                  <strong>Easy Return</strong>
                  <p>
                    14-Day Return on select items. See item guarantees for
                    details and our terms and conditions.
                  </p>
                </div>
              </div>

              <div className="card_new">
                <div className="icon">
                  <RiSecurePaymentLine fontSize={50} color="#f9a826" />
                </div>
                <div className="content">
                  <strong>100% Secure Payment</strong>
                  <p>
                    Shop with confidence knowing that your transactions are safe
                    and fully encrypted.
                  </p>
                </div>
              </div>

              <div className="card_new">
                <div className="icon">
                  <MdSupport fontSize={50} color="#f9a826" />
                </div>
                <div className="content">
                  <strong>Rapid Support</strong>
                  <p>
                    Our customer service team is available round the clock to
                    assist you with any inquiries.
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </Row>
        <Row className="footer_content">
          <Col lg={3}>
            {/* <Link href="/"> */}
            <a className="f-logo" href="/">
              <Image
                src="/assets/images/logo.webp"
                alt="Footer Logo"
                loading="lazy"
              />
            </a>
            {/* </Link> */}
            <p>Asset Remarketing and Management Since 1970 ™</p>
          </Col>
          <Col lg={4}>
            <div className="footer-link-wrap">
              <div className="f-link-50">
                <h6>Quick Links</h6>
                <ul className="custom-list">
                  <li>
                    <a href="/Inventory">Inventory</a>
                  </li>
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                  <li>
                    <a href="/recycling-services">Recycling Services</a>
                  </li>
                  <li>
                    <a href="/sell-to-us">Sell to us</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact us</a>
                  </li>
                </ul>
              </div>
              <div className="f-link-50">
                <h6>Support Links</h6>
                <ul className="custom-list">
                  <li>
                    <a href="/terms-of-service">Terms of services</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/careers">Careers</a>
                  </li>
                  <li>
                    <a href="/login">Login</a>
                  </li>
                  <li>
                    <a href="/sign-up">Signup</a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>

          <Col lg={3}>
            <h6>Get in touch</h6>
            <ul className="contact-links">
              <li>
                <a href="mailto:support@kingsurplus.com">
                  <Icon icon="fluent:mail-16-filled" /> support@kingsurplus.com
                </a>
              </li>
              <li>
                <a href="tel:830-775-2580">
                  <span>
                    <Icon icon="fluent:call-16-filled" />
                  </span>{" "}
                  +1 830-775-2580
                </a>
              </li>
              <li>
                <a
                  aria-label="Del Rio Office Address"
                  target="_blank"
                  href="https://www.google.com/maps/place/King+Surplus/@29.3613014,-100.9104766,17z/data=!3m1!4b1!4m6!3m5!1s0x86f5eb41b0888ad5:0x517d7501410f352a!8m2!3d29.3613014!4d-100.9104766!16s%2Fg%2F11dyzkq39t"
                >
                  <Icon icon="carbon:location-filled" /> 100 Ave T #4564, Del
                  Rio, TX 78840, United States
                </a>
              </li>
              <li>
                <a
                  aria-label="Comfort Office Address"
                  target="_blank"
                  href="https://www.google.com/maps/place/King+Surplus/@29.9864958,-98.9042339,15z/data=!4m6!3m5!1s0x865bf3259adf637d:0x79383dc7818f09a7!8m2!3d29.9864958!4d-98.9042339!16s%2Fg%2F11s8hzpm_2"
                >
                  <Icon icon="carbon:location-filled" /> 102 US Highway 87
                  Comfort, TX - 78013
                </a>
              </li>
            </ul>
          </Col>
          <Col lg={2}>
            <h6>Working Hours</h6>
            <ul className="contact-links">
              <li>
                <a href="#">
                  <Icon icon="fluent:clock" />
                  Monday - Friday 8AM - 5PM CST
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      <hr />
      <Container>
        <div className="CopyrightWrap">
          <p className="copyright">
            © 2025 King Surplus. All rights reserved. Trademarks and brands
            belong to their respective owners.
          </p>
          <div className="payment_icons_container">
            <ul className="payment-icons">
              <li>
                <FaCcVisa fontSize={24} />
              </li>
              <li>
                <FaCcStripe fontSize={24} />
              </li>
              <li>
                <FaCcMastercard fontSize={24} />
              </li>
              <li>
                <CiBank fontSize={24} />
              </li>
            </ul>
          </div>
          <ul className="social-ul">
            <li>
              <a
                aria-label="Facebook Page"
                target="_blank"
                href="https://www.facebook.com/kingsurpluscompany"
              >
                <FaFacebook fontSize={24} />
              </a>
            </li>
            <li>
              <a
                aria-label="Youtube Channel"
                target="_blank"
                href="https://www.youtube.com/channel/UCF8d0msOA2luUKhzA4Ap-JA"
              >
                <FaYoutube fontSize={24} />
              </a>
            </li>
            <li>
              <a
                aria-label="LinkedIn Profile"
                target="_blank"
                href="https://www.linkedin.com/company/king-surplus/"
              >
                <FaLinkedin fontSize={24} />
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
}
